"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCTS = void 0;
var PRODUCTS = {
  TEXT__PRODUCT_NAME: 'products-span-productName',
  TEXT__PRODUCT_CATEGORY: 'products-span-productCategory',
  TEXT__PRODUCT_SKU: 'products-span-productSKU',
  TEXT__PRODUCT_EXPIRES_SOON: 'products-span-expiresSoon',
  TEXT__PRODUCT_PAR_LEVEL_REACHED: 'products-span-parLevelReached',
  TEXT__PRODUCT_WAREHOUSE: 'products-span-productWarehouse',
  TEXT__PRODUCT_PAR_LEVEL: 'products-span-productParLevel',
  TEXT__PRODUCT_STOCK: 'products-span-productStock',
  TEXT__PRODUCT_SUPPLIER: 'products-span-productSupplier',
  TEXT__PRODUCT_IMPORT_TYPE: 'products-span-productImportType',
  TEXT__PRODUCT_ORDERING_UNIT: 'products-span-productOrderingUnit',
  TEXT__PRODUCT_COGS: 'products-span-productCOGS',
  TEXT__PRODUCT_PRICE: 'products-span-productPrice',
  TEXT__PRODUCT_OUT_OF_STOCK: 'products-span-productOutOfStock',
  TEXT__PRODUCT_LOW_INVENTORY: 'products-span-productLowInventory',
  INPUT__PRODUCT_QUANTITY: 'products-input-productQuantity',
  BUTTON__PRODUCT_ADD_TO_CART: 'products-span-productAddToCart'
};
exports.PRODUCTS = PRODUCTS;